// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__q3V9s","fileBtn":"File_fileBtn__3hDiq","closeBtn":"File_closeBtn__UTkVB","fileSelected":"File_fileSelected__bXrKI","disabled":"File_disabled__gqefQ"};